import { escapeZplField } from "./escape";
import { extractPlaceholders, type ZplPlaceholders } from "./helpers";

export interface RenderTemplateOptions {
  /** Placeholder names allowed for this template. Unknown placeholders throw. */
  allowedPlaceholders?: readonly string[];
}

/**
 * Render a `.zpl` template by substituting `{{name}}` occurrences with
 * ZPL-escaped values. Missing values render as empty strings.
 */
export function renderZplTemplate(
  template: string,
  data: ZplPlaceholders,
  options: RenderTemplateOptions = {},
): string {
  if (options.allowedPlaceholders) {
    const used = extractPlaceholders(template);
    const allowed = new Set(options.allowedPlaceholders);
    for (const name of used) {
      if (!allowed.has(name)) {
        throw new Error(`Unknown ZPL placeholder: {{${name}}}`);
      }
    }
  }

  return template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, name: string) => {
    const raw = data[name];
    return escapeZplField(raw);
  });
}
